import { ChangeDetectorRef, Component } from '@angular/core'
import { MatDialogRef } from '@angular/material'
import { BaseDialogComponent } from '../../../../../../base/dialog-base/dialog-base.component'
import { NomadeService } from '../../../../../../nomade/services/nomade.service'
import { DialogService } from '../../../../../../services'

@Component({
	selector: 'atyl-nomade-deactivator-dialog',
	templateUrl: './nomade-deactivator-dialog.component.html',
	styleUrls: ['./nomade-deactivator-dialog.component.scss']
})
export class NomadeDeactivatorDialogComponent extends BaseDialogComponent {

	isOpen: boolean
	constructor(
		dialogRef: MatDialogRef<NomadeDeactivatorDialogComponent>,
		dialogService: DialogService,
		changeDetectorRef: ChangeDetectorRef,
		private nomadeService: NomadeService
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	confirm(event: MouseEvent): void {
		console.log("NomadeDeactivatorDialogComponent confirm",event)
		this.nomadeService.deactivate()
	}
}
